import { render } from "./FreePtCountdown.vue?vue&type=template&id=40103788&scoped=true"
import script from "./FreePtCountdown.vue?vue&type=script&lang=js"
export * from "./FreePtCountdown.vue?vue&type=script&lang=js"

import "./FreePtCountdown.vue?vue&type=style&index=0&id=40103788&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40103788"]])

export default __exports__